<h1><a href="/admin-home">Admin</a> - Fleet Status</h1>

<section>
  <mat-form-field class="form-field-country">
    <mat-label>Country</mat-label>
    <mat-select [(ngModel)]="country" (selectionChange)="displayDealers()">
      <mat-option>
        <ngx-mat-select-search [formControl]="searchCtrl" placeholderLabel="Search..."
          noEntriesFoundLabel="No results"></ngx-mat-select-search>
      </mat-option>
      @for (c of (filteredCountries | async) ?? countriesList; track c) {
      <mat-option [value]="c.countryCode3">
        {{c.countryName + ' - ' + c.countryCode3}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  &nbsp;&nbsp;
  <mat-form-field>
    <mat-label>Enrolled</mat-label>
    <mat-select id="filterSubscribed" class="select" [(ngModel)]="subscribed" (selectionChange)="displayDealers()">
      @for(s of subscribedFlags; track s) {
      <mat-option [value]="s.field">
        {{ s.value }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  &nbsp;&nbsp;
  <button mat-raised-button color="primary" (click)="exportToExcel()">
    Download {{country}} Report
  </button>

  &nbsp;&nbsp;
  <button mat-raised-button color="primary" (click)="exportToExcel(true)">
    Download All
  </button>
</section>

<section>
  <p>{{loading}}</p>

  <mat-form-field>
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchText" (keyup)="applyFilter($event)" />
    @if(searchText) {
    <button matSuffix mat-icon-button aria-label="Clear search" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>

  <div class="mat-elevation-z8 report-table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="pa_code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FIN Code </th>
        <td mat-cell *matCellDef="let element"> {{element.pa_code}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Country </th>
        <td mat-cell *matCellDef="let element"> {{element.country}} </td>
      </ng-container>

      <ng-container matColumnDef="tech_count">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Subscriptions </th>
        <td mat-cell *matCellDef="let element" class="number"> {{element.tech_count}} </td>
      </ng-container>

      <ng-container matColumnDef="subscribed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Enrolled </th>
        <td mat-cell *matCellDef="let element"> {{element.subscribed}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <button mat-button color="primary" (click)="fly(element)">
            Be {{element.pa_code}}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 40, 80]" showFirstLastButtons>
    </mat-paginator>
  </div>
  <br>
</section>

<!-- <section>
  <p>{{loading}}</p>
  <table class="data fleet-data">
    <thead>
      <tr>
        <td>FIN Code</td>
        <td>Name</td>
        <td>Country</td>
        <td>Subscriptions</td>
        <td>Enrolled</td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      @for (dealer of displayedDealers; track dealer) {
        <tr>
          <td>{{dealer.pa_code}}</td>
          <td>{{dealer.name}}</td>
          <td>{{dealer.country}}</td>
          <td class="number">{{dealer.tech_count}}</td>
          <td>{{dealer.subscribed}}</td>
          <td><button (click)="fly(dealer)">Be {{dealer.pa_code}}</button></td>
        </tr>
      }
    </tbody>
  </table>
</section> -->